import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "text-lg font-semibold" }
const _hoisted_4 = { class: "mt-2 text-gray-600" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-12" }
const _hoisted_8 = { class: "d-flex flex-wrap gap-2 justify-content-end mt-3" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "spinner-border spinner-border-sm ms-1",
  role: "status"
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "spinner-border spinner-border-sm ms-1",
  role: "status"
}
const _hoisted_13 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_14 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_15 = { class: "d-sm-flex align-items-center" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status"
}
const _hoisted_18 = {
  key: 1,
  class: "flaticon-plus position-relative ms-5 fs-12"
}
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_21 = { class: "d-flex align-items-center mb-20" }
const _hoisted_22 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_23 = {
  key: 1,
  class: "text-info"
}
const _hoisted_24 = { key: 2 }
const _hoisted_25 = {
  key: 3,
  class: "text-nowrap"
}
const _hoisted_26 = {
  key: 4,
  class: "text-nowrap"
}
const _hoisted_27 = { key: 5 }
const _hoisted_28 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_29 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_30 = { class: "d-sm-flex align-items-center" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_33 = {
  key: 1,
  class: "flaticon-delete position-relative ms-5 fs-12"
}
const _hoisted_34 = { class: "d-flex align-items-center" }
const _hoisted_35 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_36 = { class: "d-flex align-items-center mb-20" }
const _hoisted_37 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_38 = {
  key: 1,
  class: "text-info"
}
const _hoisted_39 = { key: 2 }
const _hoisted_40 = {
  key: 3,
  class: "text-nowrap"
}
const _hoisted_41 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.deliveryNote.note_ref), 1),
        _createElementVNode("p", _hoisted_4, [
          _cache[13] || (_cache[13] = _createTextVNode(" Date de création : ", -1)),
          (_ctx.deliveryNote.created_at)
            ? (_openBlock(), _createElementBlock("b", _hoisted_5, _toDisplayString(_ctx.getDate(_ctx.deliveryNote.created_at)), 1))
            : _createCommentVNode("", true),
          _cache[14] || (_cache[14] = _createTextVNode(" | Client : ", -1)),
          _createElementVNode("b", null, _toDisplayString(_ctx.deliveryNote.note_customer_name), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (
                  _ctx.deliveryNote.note_saved != 1 &&
                  _ctx.deliveryNote.note_total_parcel != 0
                )
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-bluecol",
                    style: {"border-color":"#7367f0 !important","background-color":"#7367f0 !important","color":"#fff !important"},
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.SaveDelivery && _ctx.SaveDelivery(...args))),
                    disabled: _ctx.load_save
                  }, [
                    _cache[16] || (_cache[16] = _createElementVNode("i", { class: "flaticon-diskette lh-1 me-8 position-relative top-1" }, null, -1)),
                    _cache[17] || (_cache[17] = _createTextVNode(" Enregistrer ", -1)),
                    (_ctx.load_save)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _cache[15] || (_cache[15] = [
                          _createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
                        ])))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_9))
                : _createCommentVNode("", true),
              (
                  _ctx.deliveryNote.note_saved != 0 &&
                  _ctx.deliveryNote.note_total_parcel != 0
                )
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn btn-warning",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.GetPDF(_ctx.deliveryNote)))
                  }, _cache[18] || (_cache[18] = [
                    _createElementVNode("i", { class: "flaticon-printer lh-1 me-8 position-relative top-1" }, null, -1)
                  ])))
                : _createCommentVNode("", true),
              (
                  _ctx.deliveryNote.note_saved != 0 &&
                  _ctx.deliveryNote.note_total_parcel != 0
                )
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "btn btn-success",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.GetTicketPDF(_ctx.deliveryNote)))
                  }, _cache[19] || (_cache[19] = [
                    _createElementVNode("i", { class: "flaticon-menu lh-1 me-8 position-relative top-1" }, null, -1)
                  ])))
                : _createCommentVNode("", true),
              (
                  _ctx.deliveryNote.note_saved != 0 &&
                  _ctx.deliveryNote.note_total_parcel != 0
                )
                ? (_openBlock(), _createElementBlock("button", {
                    key: 3,
                    class: "btn btn-info",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.GetTicket4PDF(_ctx.deliveryNote)))
                  }, _cache[20] || (_cache[20] = [
                    _createElementVNode("i", { class: "flaticon-more-1 lh-1 me-8 position-relative top-1" }, null, -1)
                  ])))
                : _createCommentVNode("", true),
              (
                  _ctx.deliveryNote.note_saved != 0 &&
                  _ctx.deliveryNote.note_total_parcel != 0
                )
                ? (_openBlock(), _createElementBlock("button", {
                    key: 4,
                    class: "btn btn-primary",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.OpenBL(_ctx.deliveryNote.id))),
                    disabled: _ctx.load_open
                  }, [
                    _cache[22] || (_cache[22] = _createElementVNode("i", { class: "flaticon-unlock lh-1 me-8 position-relative top-1" }, null, -1)),
                    _cache[23] || (_cache[23] = _createTextVNode(" Ouvrir ", -1)),
                    (_ctx.load_open)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[21] || (_cache[21] = [
                          _createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
                        ])))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_11))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _cache[31] || (_cache[31] = _createElementVNode("div", { class: "border-b p-4" }, [
        _createElementVNode("h3", { class: "text-lg font-semibold" }, "Liste des nouveaux colis")
      ], -1)),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          (_ctx.deliveryNote.note_saved == 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                type: "button",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addNewColis && _ctx.addNewColis(...args))),
                disabled: _ctx.load_save
              }, [
                (_ctx.load_save)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17))
                  : _createCommentVNode("", true),
                _createElementVNode("span", null, _toDisplayString(_ctx.load_save ? "Ajout en cours..." : "Ajouter"), 1),
                (!_ctx.load_save)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_18))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_16))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchTerm1) = $event)),
            class: "form-control shadow-none text-black rounded-0",
            placeholder: "Chercher"
          }, null, 512), [
            [_vModelText, _ctx.searchTerm1]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _cache[25] || (_cache[25] = _createElementVNode("label", { class: "me-2 text-paragraph fw-medium" }, "Afficher :", -1)),
          _withDirectives(_createElementVNode("select", {
            class: "form-select form-select-sm w-auto",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.users.per_page) = $event)),
            onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.getRows1 && _ctx.getRows1(...args)))
          }, _cache[24] || (_cache[24] = [
            _createElementVNode("option", { value: 10 }, "10", -1),
            _createElementVNode("option", { value: 50 }, "50", -1),
            _createElementVNode("option", { value: 100 }, "100", -1),
            _createElementVNode("option", { value: 500 }, "500", -1)
          ]), 544), [
            [_vModelSelect, _ctx.users.per_page]
          ]),
          _cache[26] || (_cache[26] = _createElementVNode("span", { class: "ms-2 text-paragraph" }, "lignes", -1))
        ]),
        _createVNode(_component_vue_good_table, {
          columns: _ctx.columns,
          rows: _ctx.rows1,
          "row-key": 'id',
          "select-options": {
            enabled: true,
            clearSelectionText: 'Annuler',
            selectionText: 'Demandes Sélectionées',
          },
          onSelectedRowsChange: _ctx.selectionChanged,
          onSelectAll: _ctx.onSelectAll
        }, {
          emptystate: _withCtx(() => _cache[27] || (_cache[27] = [
            _createElementVNode("div", { class: "text-center py-4 text-gray" }, " Aucune entrées correspondants trouvés ", -1)
          ])),
          "table-row": _withCtx((props) => [
            (props.column.field === 'code')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (props.row.replace == 1)
                    ? (_openBlock(), _createElementBlock("h6", _hoisted_22, [
                        _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                        _cache[28] || (_cache[28] = _createElementVNode("i", { class: "flaticon-refresh" }, null, -1))
                      ]))
                    : (props.row.partial == 1)
                      ? (_openBlock(), _createElementBlock("h6", _hoisted_23, [
                          _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                          _cache[29] || (_cache[29] = _createElementVNode("i", { class: "flaticon-corner-down-left" }, null, -1))
                        ]))
                      : (_openBlock(), _createElementBlock("h6", _hoisted_24, _toDisplayString(props.row.code), 1))
                ], 64))
              : (props.column.field === 'status')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                    style: _normalizeStyle({ '--dynamic-bg': props.row.statut.code_color })
                  }, _toDisplayString(props.row.statut.s_name), 5))
                : (props.column.field === 'price')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("b", null, _toDisplayString(props.row.price), 1),
                      _cache[30] || (_cache[30] = _createTextVNode(" DH ", -1))
                    ], 64))
                  : (props.column.field === 'updated_at')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.getDate(props.row.updated_at)), 1))
                    : (props.column.field === 'created_at')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.getDate(props.row.created_at)), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows", "onSelectedRowsChange", "onSelectAll"]),
        _createVNode(_component_PaginatorContent, {
          pagination: _ctx.users,
          onPaginate: _ctx.getRows1,
          offset: 9
        }, null, 8, ["pagination", "onPaginate"])
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _cache[39] || (_cache[39] = _createElementVNode("div", { class: "border-b p-4" }, [
        _createElementVNode("h3", { class: "text-lg font-semibold" }, "Liste des colis ajoutés")
      ], -1)),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          (_ctx.deliveryNote.note_saved == 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-danger fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                type: "button",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.removeNewColis && _ctx.removeNewColis(...args))),
                disabled: _ctx.load_save
              }, [
                (_ctx.load_save)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_32))
                  : _createCommentVNode("", true),
                _createElementVNode("span", null, _toDisplayString(_ctx.load_save ? "Suppression..." : "Supprimer"), 1),
                (!_ctx.load_save)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_33))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_31))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_34, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.searchTerm2) = $event)),
            class: "form-control shadow-none text-black rounded-0",
            placeholder: "Chercher"
          }, null, 512), [
            [_vModelText, _ctx.searchTerm2]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _cache[33] || (_cache[33] = _createElementVNode("label", { class: "me-2 text-paragraph fw-medium" }, "Afficher :", -1)),
          _withDirectives(_createElementVNode("select", {
            class: "form-select form-select-sm w-auto",
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.users2.per_page) = $event)),
            onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.getRows2 && _ctx.getRows2(...args)))
          }, _cache[32] || (_cache[32] = [
            _createElementVNode("option", { value: 10 }, "10", -1),
            _createElementVNode("option", { value: 50 }, "50", -1),
            _createElementVNode("option", { value: 100 }, "100", -1),
            _createElementVNode("option", { value: 500 }, "500", -1)
          ]), 544), [
            [_vModelSelect, _ctx.users2.per_page]
          ]),
          _cache[34] || (_cache[34] = _createElementVNode("span", { class: "ms-2 text-paragraph" }, "lignes", -1))
        ]),
        _createVNode(_component_vue_good_table, {
          "search-options": { enabled: true, externalQuery: _ctx.searchTerm2 },
          columns: _ctx.columns,
          "row-key": 'id',
          rows: _ctx.rows2,
          responsive: "",
          "select-options": {
            enabled: true,
            clearSelectionText: 'Annuler',
            selectionText: 'Demandes Sélectionées',
          },
          onSelectAll: _ctx.onSelectAllColis,
          onSelectedRowsChange: _ctx.selectionChangedColis
        }, {
          emptystate: _withCtx(() => _cache[35] || (_cache[35] = [
            _createElementVNode("div", { class: "text-center py-4 text-gray" }, " Aucune entrées correspondants trouvés ", -1)
          ])),
          "table-row": _withCtx((props) => [
            (props.column.field === 'code')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (props.row.replace == 1)
                    ? (_openBlock(), _createElementBlock("h6", _hoisted_37, [
                        _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                        _cache[36] || (_cache[36] = _createElementVNode("i", { class: "flaticon-refresh" }, null, -1))
                      ]))
                    : (props.row.partial == 1)
                      ? (_openBlock(), _createElementBlock("h6", _hoisted_38, [
                          _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                          _cache[37] || (_cache[37] = _createElementVNode("i", { class: "flaticon-corner-down-left" }, null, -1))
                        ]))
                      : (_openBlock(), _createElementBlock("h6", _hoisted_39, _toDisplayString(props.row.code), 1))
                ], 64))
              : (props.column.field === 'price')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("b", null, _toDisplayString(props.row.price), 1),
                    _cache[38] || (_cache[38] = _createTextVNode(" DH ", -1))
                  ], 64))
                : (props.column.field === 'status')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                      style: _normalizeStyle({ '--dynamic-bg': props.row.statut.code_color })
                    }, _toDisplayString(props.row.statut.s_name), 5))
                  : (props.column.field === 'created_at')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_ctx.getDate(props.row.created_at)), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["search-options", "columns", "rows", "onSelectAll", "onSelectedRowsChange"]),
        _createVNode(_component_PaginatorContent, {
          pagination: _ctx.users2,
          onPaginate: _ctx.getRows2,
          offset: 9
        }, null, 8, ["pagination", "onPaginate"])
      ])
    ])
  ]))
}